import { useUserStore } from '../stores/useUserStore';
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Hook de conveniencia para acceder al perfil del usuario
 * Proporciona acceso fácil a los datos del usuario y su empresa
 */
export const useUserProfile = () => {
  const { getAccessTokenSilently } = useAuth0();
  const {
    userProfile,
    isLoading,
    error,
    isInitialized,
    fetchUserProfile,
    refreshUserProfile,
    clearUserProfile,
    getUserRole,
    getUserCompany,
    isCompanyOwner
  } = useUserStore();

  return {
    // Datos del usuario
    user: userProfile,
    
    // Estado de carga
    isLoading,
    isInitialized,
    
    // Errores
    error,
    
    // Información del usuario
    userId: userProfile?.id,
    userEmail: userProfile?.email,
    userName: userProfile?.full_name,
    userRole: getUserRole(),
    
    // Información de la empresa
    company: getUserCompany(),
    companyId: userProfile?.personal_company?.id,
    companyName: userProfile?.personal_company?.name,
    isCompanyOwner: isCompanyOwner(),
    
    // Acciones
    fetchUserProfile: () => fetchUserProfile(),
    refreshProfile: () => refreshUserProfile(),
    clearProfile: clearUserProfile,
    fetchProfile: () => fetchUserProfile()
  };
};
